import { jsxs as u, jsx as t } from "react/jsx-runtime";
import l from "react";
import n, { css as r } from "styled-components";
import { _ as B, b as L, a as T, h as j, i as E } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { a as M, R as F, B as O } from "../chunks/index.b09c00db.js";
import { a as v, R as W } from "../chunks/index.cff5baaf.js";
import { g as G } from "../chunks/mask.38d91945.js";
import { RangoCreditCard as Y } from "./CreditCard.js";
const a = {
  Card: "Card",
  Validate: "Validate",
  CVV: "CVV"
};
Object.values(a);
const q = n.div.withConfig({
  displayName: "RangoInputCard",
  componentId: "sc-1xkmmr8-0"
})(["& *{margin:0;padding:0;}width:100%;display:flex;flex-direction:column;gap:var(--spacing-1x);", ""], ({
  disabled: o
}) => o && r(["opacity:var(--opacity-low);pointer-events:none;"])), A = n.label.withConfig({
  displayName: "Label",
  componentId: "sc-1xkmmr8-1"
})(["", " color:var(--text-label-color);", " ", " ", ""], B, ({
  $clicked: o
}) => o && r(["color:var(--active-label-color);"]), ({
  disabled: o
}) => o && r(["color:var(--disabled-label-color);"]), ({
  $error: o
}) => o && r(["color:var(--negative-label-color);"])), D = n.div.withConfig({
  displayName: "Element",
  componentId: "sc-1xkmmr8-2"
})(["height:var(--size-8x);width:100%;display:flex;align-items:center;border:var(--default-border-width) solid var(--elements-border-color);border-radius:var(--default-border-radius);box-sizing:border-box;padding:var(--spacing-2x);transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);", " ", " ", " ", " ", ""], ({
  type: o
}) => (o === a.CVV || o === a.Validate) && r(["padding-right:0;"]), ({
  $clicked: o
}) => o && r(["border-color:var(--active-border-color);transition-property:all;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);outline:transparent;"]), ({
  disabled: o
}) => o && r(["border-color:var(--disabled-border-color);"]), ({
  $clicked: o
}) => !o && r(["&:has(input:focus:not(:active)){", " outline-offset:2px;border-color:var(--active-border-color);}&:hover{", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}"], L, T), ({
  $error: o
}) => o && r(["border-color:var(--negative-border-color) !important;& input{padding-right:var(--spacing-1x);}"])), H = n.input.withConfig({
  displayName: "Input",
  componentId: "sc-1xkmmr8-3"
})(["", " color:var(--active-placeholder-color);width:100%;height:var(--size-8x);outline:none;border:none;box-sizing:border-box;border-radius:inherit;background-color:transparent;padding-right:0px;&:-webkit-autofill{-webkit-background-clip:text;}", " &:disabled{background-color:transparent;color:var(--disabled-placeholder-color);&::placeholder{color:var(--disabled-placeholder-color);}}&::placeholder{color:var(--text-placeholder-color);}", " ", ""], j, ({
  $error: o
}) => !o && r(["&:focus-within:not(:active){color:var(--active-placeholder-color);}"]), ({
  $clicked: o,
  $error: e
}) => o && !e && r(["color:var(--active-placeholder-color);"]), ({
  $error: o
}) => o && r(["color:var(--negative-placeholder-color);&::placeholder{color:var(--negative-placeholder-color);}"])), J = n.div.withConfig({
  displayName: "Icons",
  componentId: "sc-1xkmmr8-4"
})(["height:100%;margin-right:var(--size-half);display:flex;align-items:center;", "{background-color:transparent;}", "{color:var(--elements-icon-color);}", " ", ""], M, v, ({
  disabled: o
}) => o && r(["", "{color:var(--disabled-icon-color);}"], v), ({
  $error: o
}) => o && r(["", "{color:var(--negative-icon-color);}"], v)), K = n.p.withConfig({
  displayName: "SupportText",
  componentId: "sc-1xkmmr8-5"
})(["", " color:var(--text-support-text-color);", " ", ""], E, ({
  disabled: o
}) => o && r(["color:var(--disabled-support-text-color);"]), ({
  $error: o
}) => o && r(["color:var(--negative-support-text-color);"])), P = n.div.withConfig({
  displayName: "CreditCardImage",
  componentId: "sc-1xkmmr8-6"
})(["margin-right:var(--size-1x);display:flex;align-items:center;justify-content:center;"]), Q = l.forwardRef(({
  id: o = "",
  disabled: e = !1,
  error: i = !1,
  label: x = "",
  placeholder: C = "",
  supportText: m = "",
  type: c = a.Card,
  flag: b = "Elo",
  buttonIconAriaLabel: k = "",
  handleClickHelper: I,
  ...d
}, y) => {
  const V = l.useRef(), [s, g] = l.useState(!1), [w, R] = l.useState(!1), [$, N] = l.useState(""), _ = () => ({
    [a.Card]: "creditCard",
    [a.Validate]: "monthYear",
    [a.CVV]: "cvv"
  })[c], h = (p) => {
    const f = p.target, S = G({
      value: f.value,
      maskType: _()
    });
    N(S), R(!!f.value);
  }, z = (p) => {
    g(!0), "onClick" in d && d.onClick(p);
  };
  return /* @__PURE__ */ u(q, { ...d, ref: y, disabled: e, "data-testid": "rango-input-card", "data-rango-component": "rango-input-card", "data-is-rango": !0, children: [
    /* @__PURE__ */ t(A, { $clicked: s, disabled: e, $error: i && !e, htmlFor: o, children: x }),
    /* @__PURE__ */ u(D, { disabled: e, $error: i && !e, $clicked: s, type: c, children: [
      c === a.Card && /* @__PURE__ */ t(P, { children: /* @__PURE__ */ t(Y, { flag: b }) }),
      /* @__PURE__ */ t(H, { type: "text", id: o, ref: V, value: $, placeholder: C, $clicked: s, $filled: w, disabled: e, $error: i && !e, onClick: z, onBlur: () => g(!1), onInput: h, onChange: h }),
      /* @__PURE__ */ u(J, { disabled: e, $error: i && !e, children: [
        i && !e && /* @__PURE__ */ t(W, { icon: "NegativeLine" }),
        (c === a.CVV || c === a.Validate) && /* @__PURE__ */ t(F, { "aria-label": k, disabled: e, size: O.LG, icon: "SupportLine", onClick: I })
      ] })
    ] }),
    m && /* @__PURE__ */ t(K, { disabled: e, $error: i && !e, children: m })
  ] });
});
Q.displayName = "RangoInputCard";
export {
  a as InputCardType,
  Q as RangoInputCard
};
